<template>
  <div>
    <div>
      Type the call ID, phone number and/or the caller’s name to narrow your
      search
    </div>
    <inactive-calls-datatable
      :source="source"
      :filters="filters"
    ></inactive-calls-datatable>
  </div>
</template>

<script>
import InactiveCallsDatatable from "./InactiveCallsDatatable.vue";
export default {
  components: { InactiveCallsDatatable },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped></style>
